/*
 * circ-upsell.js
 * One-click BOGO + protector upsell handler for the cart drawer.
 * Listens for clicks on [data-circ-add] buttons, POSTs to /cart/add.js
 * with sections= so Horizon's cart-items-component can morph in place.
 */
(function () {
  'use strict';

  var ADDED_DWELL_MS = 1400;

  function getSectionIds() {
    var ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  }

  function addToCart(variantId, sectionIds) {
    var body = { id: variantId, quantity: 1 };
    if (sectionIds && sectionIds.length) body.sections = sectionIds.join(',');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (resp) {
      if (!resp.ok) {
        return resp.json().catch(function () { return {}; }).then(function (err) {
          throw new Error(err.description || err.message || 'Unable to add to cart');
        });
      }
      return resp.json();
    });
  }

  function dispatchCartUpdate(payload) {
    try {
      var detail = {
        resource: payload,
        sourceId: 'circ-upsell',
        data: {
          source: 'circ-upsell',
          sections: payload && payload.sections ? payload.sections : {},
          itemCount: payload && typeof payload.item_count === 'number' ? payload.item_count : undefined,
          variantId: payload && payload.items && payload.items[0] && payload.items[0].variant_id
        }
      };
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
    } catch (e) {
      // Non-fatal. Drawer just stays stale until the next interaction.
    }
  }

  function handleClick(event) {
    var btn = event.target.closest ? event.target.closest('[data-circ-add]') : null;
    if (!btn) return;
    if (btn.dataset.busy === 'true' || btn.disabled) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-circ-add');
    if (!variantId) return;

    var labelEl = btn.querySelector('.circ-upsell__cta-text') || btn;
    var originalLabel = btn.getAttribute('data-circ-label') || labelEl.textContent;

    btn.dataset.busy = 'true';
    labelEl.textContent = 'Adding…';

    addToCart(variantId, getSectionIds())
      .then(function (payload) {
        labelEl.textContent = 'Added';
        btn.dataset.added = 'true';
        dispatchCartUpdate(payload);
      })
      .catch(function (err) {
        if (window && window.console) console.error('[circ-upsell]', err);
        labelEl.textContent = 'Try again';
        btn.dataset.busy = 'false';
        setTimeout(function () {
          if (btn.dataset.busy !== 'true') labelEl.textContent = originalLabel;
        }, ADDED_DWELL_MS);
      });
  }

  document.addEventListener('click', handleClick);
})();
